import { CUSTOMER_JOURNEY_CATEGORIES_SUCCESS } from './../const';

function action(data, successCallback) {
  return { type: CUSTOMER_JOURNEY_CATEGORIES_SUCCESS, data, successCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyCategoriesSuccess.js